export default __webpack_public_path__ + "static/media/C0001.9e3574e5.png";